import React from 'react';
import { observer } from 'mobx-react';
import BoxTrackBlock from './BoxTrackBlock';
const BoxTrack = observer(function ({ model, track, }) {
    const { blocksX, msaAreaWidth } = model;
    const { height } = track.model;
    return (React.createElement("div", { style: {
            position: 'relative',
            height,
            width: msaAreaWidth,
            overflow: 'hidden',
        } }, blocksX.map(bx => (React.createElement(BoxTrackBlock, { track: track, key: bx, model: model, offsetX: bx })))));
});
export default BoxTrack;
//# sourceMappingURL=BoxTrack.js.map